<template>
	<div class="mobile-search">
		<el-input
			:placeholder="computedPlaceholder"
			v-model="innerValue"
			class="search-input"
			@input="inputSearch"
			clearable
		>
			<SvgIcons name="search" slot="prefix" class="iconfont" />
		</el-input>
	</div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { debounce } from '@/utils/api';

const { proxy } = getCurrentInstance();

const props = defineProps({
	value: {
		type: String
	},
	placeholder: {
		type: String,
		default: ''
	}
});
const emits = defineEmits(['update:value', 'change']);
const computedPlaceholder = computed(() => props.placeholder || proxy.$t('enterprise.default-search'));

const innerValue = computed({
	get: () => props.value,
	set: val => {
		emits('update:value', val);
	}
});
const inputSearch = debounce(function (val) {
	emits('change', val);
}, 200);
</script>

<style lang="less" scoped>
.mobile-search {
	width: 100%;
	padding: 6px 16px;
	display: flex;
	align-items: center;
	.search-input {
		.iconfont {
			font-size: 16px;
			color: #4e5969;
		}
	}
	/deep/ .el-input__inner {
		border-radius: 4px;
		background: #f2f3f5;
		border: none;
	}
	/deep/.el-input__prefix {
		left: 0;
		width: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
